import {all, call, put, takeLatest} from 'redux-saga/effects';
import settingsActions from '../actions/settings.actions';
import errorActions from '../actions/error.actions';
import SettingsApi from '../api/SettingsApi';
import userActions from '../actions/user.actions';

function* updateSettings(action) {
    const emptyFunction = () => {};
    try {
        const payoutFunc = action.payload.payout ? SettingsApi.updatePayoutAccount : emptyFunction;
        const payoutAccount = yield call(payoutFunc, action.payload.payout || {});
        if (payoutAccount && payoutAccount.status === 'Error') {
            yield put(settingsActions.updateSettingsFailed());
            yield put(errorActions.showErrorMessage(payoutAccount));
            return;
        }
        yield put(
            settingsActions.updateSettingsSuccess(payoutAccount)
        );
    } catch (e) {
        const returnedEvents = [put(settingsActions.updateSettingsFailed(e))];
        if (e && e.response && e.response.status === 401) {
            returnedEvents.push(put(userActions.logoutEvent()));
        }
        yield all(returnedEvents);
    }
}

function* fetchPayout() {
    try {
        const taxInfo = yield call(SettingsApi.getTaxInfo);
        if (taxInfo.status === 'Error' && taxInfo.statusCode !== 404) {
            yield put(settingsActions.getSettingsFailed());
            yield put(errorActions.showErrorMessage(taxInfo));
            return;
        }
        const payoutAccount = yield call(SettingsApi.getPayoutAccount);
        if (payoutAccount.status === 'Error' && payoutAccount.statusCode !== 404) {
            yield put(settingsActions.getSettingsFailed());
            yield put(errorActions.showErrorMessage(payoutAccount));
            return;
        }
        yield put(
            settingsActions.getPayoutSuccess({
                taxInfo,
                payoutAccount
            })
        );
    } catch (e) {
        yield put(settingsActions.getPayoutFailed(e));
        if (e) {
            yield put(errorActions.showErrorMessage({errorMessage: e.getMessage()}));
        }
    }
}

function* fetchSettings() {
    try {
        const slugOptions = yield call(SettingsApi.getAffiliateSlugOptions);
        if (slugOptions.status === 'Error') {
            yield put(settingsActions.getSettingsFailed());
            yield put(errorActions.showErrorMessage(slugOptions));
            return;
        }
        const profile = yield call(SettingsApi.getInfluencerProfile);
        if (profile.status === 'Error' && profile.statusCode !== 404) {
            yield put(settingsActions.getSettingsFailed());
            yield put(errorActions.showErrorMessage(profile));
            return;
        }
        yield put(
            settingsActions.getSettingsSuccess({
                slugOptions,
                profile
            })
        );
    } catch (e) {
        yield put(settingsActions.getSettingsFailed(e));
        if (e) {
            yield put(errorActions.showErrorMessage({errorMessage: e.getMessage()}));
        }
    }
}

function* settingsSaga() {
    yield takeLatest(settingsActions.TYPES.GET_SETTINGS, fetchSettings);
    yield takeLatest(settingsActions.TYPES.UPDATE_SETTINGS, updateSettings);
    yield takeLatest(settingsActions.TYPES.GET_PAYOUT, fetchPayout);
}

export default settingsSaga;
